/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-07 16:37:36
 * @LastEditTime: 2025-04-08 15:30:16
 * @LastEditors: ywj@originqc.com
 */
import React from "react";
import { Modal, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { openCustomerService } from '@/utils/index'
import { transferable} from '@/api/personal-center'
import ProcessTips from '../../../components/process-tips'
import './index.scss';

interface IProcess { 
  showProcessModal: boolean,
  setShowProcessModal: (showProcessModal: boolean) => void,
  type: 'payment' | 'close' | 'order'
//   payment:待支付页面进来的，
//   close：我的订单进来的，并且是关闭按钮，
// order: 我的订单进来的，不展示切换支付方式
  // setPaySuccess: (paySuccess: boolean) => void;
  // setPayWay: (payWay: number) => void;
  orderData: {
    id:number,
    totalAmount: string,
    qrcodeUrl: string,
    orderName: string,
    orderNo: string,
    payAmount: string,
    restTime: string,
    receiver: {
      id:number,
      name:string,
      tel:string,
      city:string,
      province:string,
      region:string,
      detailAddress:string,

    }
  }
}


const ProcessModal: React.FC<IProcess> = (props) => {
  const { showProcessModal, setShowProcessModal,orderData,type='payment'} = props;
  const navigate = useNavigate();
  // const [searchParams] = useSearchParams();
  // const orderId = searchParams.get('orderId');
  const handleCancel = () => { 
    setShowProcessModal(false);
    // navigate('/user/orderList')
  }

  const handleOk = () => { 
    setShowProcessModal(false);
  }

  const handleService = () => { 
    openCustomerService();
  }
//对公确认支付
  const handleTransfer = () => { 
    if (orderData&&orderData.id) { 
      transferable(orderData.id).then((res:any) => {
        if (res.success) {
          // setPaySuccess(true);
          // setPayWay(4);
          setShowProcessModal(false);
          navigate(`/user/payment/success?orderId=${orderData.id}&payWay=4`)
        } else {
          message.error(res.message);
        }
      })
    }
   
  }
// 已确认支付
  const handleSurePay = () => { 
    handleTransfer();
  }
  return (
    <Modal
    centered
    width={900}
    title={'对公支付流程'}
    open={showProcessModal}
    // initialValues={editModalState}
      maskClosable={ false}
    onCancel={handleCancel}
    onOk={handleOk}
    className="payment-modal"
    >
      <ProcessTips
        width={220}
             startText='对公汇款' 
             endText='确认支付'/>
      {/* <img src={processPic} alt="流程" className="process-pic" /> */}
      <p className="title">账户名称：本源量子计算科技（合肥）股份有限公司</p>
      <p className="title">开户银行：中国光大银行合肥分行</p>
      <p className="title">银行账号：76690188001141124</p>
      <p className="title">汇款金额：￥{ orderData?.payAmount}</p>
      <p className="title">订单编号：{ orderData?.orderNo}</p>
      <p className="title">商品名称：{ orderData?.orderName} </p>
      <p className="notice">* 请在对公汇款时务必备注订单编号</p>
      <p className='tips'>温馨提示</p>
      <p className="tips-text">1、对公支付订单提交后24小时内有效，超时支付请联系人工客服处理</p>
      <p className="tips-text">2、人工审核确认无误后，将对订单商品发货，周末、法定假日可能有延时，请耐心等待</p>
      <p className="tips-text">3、确认支付后，您可以前往“我的订单”页面查看订单对公支付状态</p>
      <p className="tips-text">4、如有任何疑问，请联系<span className="service" onClick={handleService}>【人工客服】</span></p>
      <div className="dialog-bottom">
        {type === 'payment' && <div className="process-btn">
          <span className="btn-desc">转账完成后请点击【已确认支付】</span>
          <Button className="submit-info" onClick={handleSurePay}>已确认支付</Button>
          <Button onClick={() => setShowProcessModal(false)}>切换支付方式</Button>
        </div>}
        {type === 'close' && <div className="process-btn">
          <Button onClick={() => setShowProcessModal(false)}>关闭</Button>
        </div>}
        {type === 'order' && <div className="process-btn">
        <span className="btn-desc">转账完成后请点击【已确认支付】</span>
          <Button className="submit-info" onClick={handleSurePay}>已确认支付</Button>
        </div>}
      </div>
    </Modal>
  )

}

export default ProcessModal;
